// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3vFVU","inputDescription":"styles_inputDescription__nSVAh"};